import React from 'react';
import './Services.css';

const Services: React.FC = () => {
  const services = [

    {
      icon: '💻',
      title: 'UPS/SMPS/Inverter & Server Rack',
      description: 'Installation of uninterruptible power supplies, server racks, and power backup systems.',
      features: ['UPS Installation', 'SMPS Setup', 'Inverter Installation', 'Server Rack Installation']
    },
    {
      icon: '🔗',
      title: 'Cable Laying & Termination',
      description: 'Professional AC/DC cable laying, termination, earthing systems, and strip laying services.',
      features: ['AC/DC Cable Laying', 'Cable Termination', 'Earth Pit Installation', 'Earth Strip Laying']
    },
    {
      icon: '🔌',
      title: 'Electrical Panel and Conduit Installation',
      description: 'Installation of lighting, power, and emergency panels with expert conduiting for organized and safe cable management.',
      features: ['LDP Installation', 'PDB Installation', 'ELDB Installation', 'Conduiting']
    },
    {
      icon: '💡',
      title: 'Wiring & Electrical Fittings',
      description: 'Complete internal and external wiring solutions with lighting and power socket installations.',
      features: ['Internal Wiring', 'External Wiring', 'Light Fittings', 'Power Sockets']
    },
    {
      icon: '🖲️',
      title: 'Safety, Security, and Surveillance Systems',
      description: 'Advanced fire detection and alert solutions utilizing modern sensors and emergency signaling for complete safety compliance.',
      features: ['Fire Alarm System', 'Security Alarm System', 'CCTV Works', 'PAS System']
    }, {
      icon: '⚡',
      title: 'RMG & RMU Installation',
      description: 'Professional installation of Ring Main Units and Ring Main Gear for reliable power distribution systems.',
      features: ['RMG Installation', 'RMU Installation']
    },
    {
      icon: '🔌',
      title: 'HT LT Panel Board Installation',
      description: 'Expert installation of High Tension and Low Tension panel boards for safe electrical distribution.',
      features: ['HT Panel Installation', 'LT Panel Setup']
    },
    {
      icon: '🔋',
      title: 'Transformer & DG Set Installation',
      description: 'Complete installation and commissioning of transformers and diesel generator sets.',
      features: ['Transformer Installation', 'DG Set Setup',]
    },
  ];

  const sectors = [
    { name: 'Data Centers', icon: '🖥️' },
    { name: 'IT Buildings', icon: '🏢' },
    { name: 'Industries', icon: '🏭' },
    { name: 'Schools', icon: '🏫' },
    { name: 'Hospitals', icon: '🏥' },
    { name: 'Corporate Offices', icon: '🏢' }
  ];

  return (
    <section id="services" className="services section-padding">
      <div className="container">
        <div className="section-header text-center mb-8">
          <h2 className="section-title">Professional Electrical Contracting Services</h2>
          <p className="section-subtitle">
            Comprehensive electrical contracting solutions including solar installation, cable laying & termination,
            HT LT panel installation, transformer installation, and electrical commissioning services for residential,
            commercial, and industrial clients across Chennai and India
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-header">
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
              </div>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
              {/* Removed based on review  */}
              {/* <a href="#contact" className="service-cta">Contact Us</a> */}
            </div>
          ))}
        </div>

        <div className="sectors-section">
          <h3>Core Sectors We Serve</h3>
          <div className="sectors-grid">
            {sectors.map((sector, index) => (
              <div key={index} className="sector-card">
                <div className="sector-icon">{sector.icon}</div>
                <span className="sector-name">{sector.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-guarantee">
          <div className="guarantee-content">
            <h3>Why Choose Us</h3>
            <p>
              We stand behind every job with our comprehensive service guarantee.
              If you're not completely satisfied with our work, we'll make it right.
              All our services come with warranty coverage and ongoing support.
            </p>
            <div className="guarantee-features">
              <div className="guarantee-item">
                <span className="guarantee-icon">✅</span>
                <span>Customer Satisfaction</span>
              </div>
              <div className="guarantee-item">
                <span className="guarantee-icon">👥</span>
                <span>Experienced Team</span>
              </div>
              <div className="guarantee-item">
                <span className="guarantee-icon">💡</span>
                <span>Innovative Solutions</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
